import React from 'react';
import { motion } from 'framer-motion';
import { Sprout, Leaf, Star } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full bg-cream py-8 md:py-20 px-4 overflow-hidden" data-id="element-117">
      {/* Decorative Background Leaves */}
      <motion.div animate={{
      y: [0, -15, 0],
      rotate: [0, 5, 0]
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-10 left-4 md:left-10 opacity-10 pointer-events-none" data-id="element-118">
        <Leaf className="w-20 h-20 md:w-32 md:h-32 text-green-800" data-id="element-119" />
      </motion.div>
      <motion.div animate={{
      y: [0, 15, 0],
      rotate: [0, -5, 0]
    }} transition={{
      duration: 6,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 1
    }} className="absolute bottom-20 right-4 md:right-10 opacity-10 pointer-events-none" data-id="element-120">
        <Sprout className="w-24 h-24 md:w-40 md:h-40 text-green-800" data-id="element-121" />
      </motion.div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-122">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-123">
          <div className="inline-flex items-center gap-2 bg-green-100 border border-green-200 text-green-800 px-4 py-2 rounded-full text-xs md:text-sm font-bold mb-6 shadow-sm" data-id="element-124">
            <Star className="w-4 h-4 fill-green-600 text-green-600" data-id="element-125" />
            <span data-id="element-126">Más de 1.000 personas ya empezaron</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 md:mb-8 leading-tight" data-id="element-127">
            🌿 Dejá de gastar de más en verduras todas las semanas
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="my-6 md:my-12 flex justify-center" data-id="element-128">
          <img src="https://cdn.magicpatterns.com/uploads/vtMpkXNxumvNuWbB339aQa/Diseno_sin_titulo.png" alt="Huerta Express 30D - Sistema completo" className="w-full max-w-lg md:max-w-xl h-auto drop-shadow-2xl" data-id="element-129" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-130">
          <h2 className="text-lg md:text-2xl font-semibold text-green-800 mb-4 px-2" data-id="element-131">
            Huerta Express 30D — Cultivá en casa aunque tengas poco espacio y
            cero experiencia
          </h2>

          <p className="text-base md:text-lg text-gray-700 mb-8 max-w-2xl mx-auto px-4" data-id="element-132">
            Sistema paso a paso para empezar tu huerta en 30 días, ahorrar
            dinero y dejar de depender del supermercado.
          </p>

          <motion.a href="#pricing" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} animate={{
          boxShadow: ['0px 0px 0px rgba(132,204,22,0)', '0px 0px 20px rgba(132,204,22,0.5)', '0px 0px 0px rgba(132,204,22,0)']
        }} transition={{
          boxShadow: {
            duration: 2,
            repeat: Infinity
          }
        }} className="relative inline-flex items-center justify-center bg-lime-500 hover:bg-lime-400 text-green-950 font-extrabold text-lg md:text-xl px-8 py-4 md:px-10 md:py-5 rounded-xl shadow-lg transition-colors" data-id="element-133">
            👉 ¡QUIERO EMPEZAR AHORA!
            <Leaf className="absolute -top-3 -right-3 w-6 h-6 text-lime-600 rotate-12 drop-shadow-sm" data-id="element-134" />
            <Sprout className="absolute -bottom-2 -left-2 w-5 h-5 text-lime-600 -rotate-12 drop-shadow-sm" data-id="element-135" />
          </motion.a>
        </motion.div>
      </div>
    </section>;
}